import { render, staticRenderFns } from "./subDisc.vue?vue&type=template&id=7c4a8cbd&scoped=true&"
import script from "./subDisc.vue?vue&type=script&lang=js&"
export * from "./subDisc.vue?vue&type=script&lang=js&"
import style0 from "./subDisc.vue?vue&type=style&index=0&id=7c4a8cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a8cbd",
  null
  
)

export default component.exports